export const api = import.meta.env.VITE_CAPTURE_API || ''
